import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import Swal from 'sweetalert2';
import * as jsonManager from '../../abis/Manager.json';
import { environment } from '../../../environments/environment';
import { ConnectionsService } from '../../services/connectionsWeb3/connections.service';
import { percentage } from '@angular/fire/storage';
import { LoaderService } from '../../services/loader.service';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { StatusUpdateService } from '../../services/checkStatus/status-update.service';
import { ProjectTimelineService } from '../../services/project-timeline.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-new-proyect',
  templateUrl: './new-proyect.component.html',
  styleUrls: ['./new-proyect.component.css']
})
export class NewProyectComponent {
  id: string = Date.now().toString();
  formNewNft: FormGroup = this.createFormNewNft();
  fotoMain: string | null = null;
  foto1: string | null = null;
  foto2: string | null = null;
  foto3: string | null = null;
  foto4: string | null = null;
  foto5: string | null = null;
  foto6: string | null = null;
  foto7: string | null = null;
  foto8: string | null = null;
  foto9: string | null = null;
  foto10: string | null = null;
  whitePaper: string | null = null;
  dosier: string | null = null;
  infoToken: string | null = null;
  loadingFlag: boolean = false;

  ourAddress: string | undefined;
  web3: any | undefined;
  abiManager: any = jsonManager;
  contractManager: any | undefined;

  readonly ordenAtributos = ["Habitaciones", "Baños", "Cocina", "Comedor", "Garaje"];
  
  // Variables para manejar viviendas múltiples
  viviendasArray: FormArray<FormGroup>;
  primeraVivienda: FormGroup = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    atributos: new FormControl('', [Validators.required])
  });

  constructor(
    private storage: AngularFireStorage, 
    private afs: AngularFirestore, 
    private connSrv: ConnectionsService,
    private fns: AngularFireFunctions,
    private loaderService: LoaderService,
    private StatusUpdateService: StatusUpdateService,
    private authService: AuthService,
    private timelineService: ProjectTimelineService
  ) {
    
    this.web3 = this.connSrv.web3Instance;

    this.connSrv.addressUser.subscribe((res: string) => {
      this.ourAddress = res;
    });

    this.contractManager = new this.web3.eth.Contract(this.abiManager.abi, environment.config.ADDRESS_MANAGER);
    
    // Inicializar FormArray
    this.viviendasArray = new FormArray<FormGroup>([]);
  }

  createFormNewNft() {
    return new FormGroup({
      titulo: new FormControl(null, [Validators.required]),
      promotora: new FormControl(null, [Validators.required]),
      pais: new FormControl(null, [Validators.required]),
      estadoCCAAProvincia: new FormControl(null, [Validators.required]),
      localidad: new FormControl(null, [Validators.required]),
      barrio: new FormControl(null, [Validators.required]),
      codigoPostal: new FormControl(null, [Validators.required]),
      calle: new FormControl(null, [Validators.required]),
      iframeGoogleMaps: new FormControl(null,[Validators.required]),
      descripcion: new FormControl(null, [Validators.required]),
      fechaActivado: new FormControl(null, [Validators.required]),
      plazoEstimadoEntrega: new FormControl(null, [Validators.required]),
      rentabilidadAnual: new FormControl(0, [Validators.required, Validators.min(1)]),
      amountToSell: new FormControl(0, [Validators.required, Validators.min(1)]),
      precioToken: new FormControl(0, [Validators.required, Validators.min(0)]),
      inversionMinima: new FormControl(0, [Validators.required, Validators.min(1)]),
      stableCoinAddress: new FormControl('0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063', [Validators.required]),
      beneficiaryAddress: new FormControl(null, [Validators.required]),
      aggregatorStableCoinDolar: new FormControl('0x4746DeC9e833A82EC7C2C1356372CcF2cfcD2F3D', [Validators.required]),
      urlWhitepaperPdf: new FormControl(null),
      urlDosierPdf: new FormControl(null),
      urlInfoTokenPdf: new FormControl(null),
      urlImagenPrincipal: new FormControl(null),
      toBlockchain: new FormControl(false),
      onlyInversors: new FormControl(false),
      percentageToPrivateSale: new FormControl(75, [Validators.required, Validators.min(0), Validators.max(100)]),
      managingInvestments: new FormControl(false), // Añadido para gestionando inversiones
      nameTokens: new FormControl(null, [Validators.required]),
      symbolTokens: new FormControl(null, [Validators.required]),
      propertyType: new FormControl('Flipping House', [Validators.required]), // Tipo de propiedad
      infoProyecto: new FormControl(null, [this.urlValidator]),
      isMultipleVivienda: new FormControl(false), // Campo para controlar el tipo de formulario
      atributos: new FormControl(null, [Validators.required]) // Campo para atributos únicos (formato antiguo)
    })
  }

  get titulo() { return this.formNewNft?.get('titulo'); }
  get promotora() { return this.formNewNft?.get('promotora'); }
  get pais() { return this.formNewNft?.get('pais'); }
  get estadoCCAAProvincia() { return this.formNewNft?.get('estadoCCAAProvincia'); }
  get localidad() { return this.formNewNft?.get('localidad'); }
  get barrio() { return this.formNewNft?.get('barrio'); }
  get codigoPostal() { return this.formNewNft?.get('codigoPostal'); }
  get calle() { return this.formNewNft?.get('calle'); }
  get iframeGoogleMaps() { return this.formNewNft?.get('iframeGoogleMaps'); }
  get descripcion() { return this.formNewNft?.get('descripcion'); }
  get fechaActivado() {
    return this.formNewNft?.get('fechaActivado');
  } // Getter para el date picker
  get plazoEstimadoEntrega() { return this.formNewNft?.get('plazoEstimadoEntrega'); }
  get rentabilidadAnual() { return this.formNewNft?.get('rentabilidadAnual'); }
  get precioToken() { return this.formNewNft?.get('precioToken'); }
  get inversionMinima() { return this.formNewNft?.get('inversionMinima'); }
  get amountToSell() { return this.formNewNft?.get('amountToSell'); }
  get stableCoinAddress() { return this.formNewNft?.get('stableCoinAddress'); }
  get beneficiaryAddress() { return this.formNewNft?.get('beneficiaryAddress'); }
  get aggregatorStableCoinDolar() { return this.formNewNft?.get('aggregatorStableCoinDolar'); }
  get urlWhitepaperPdf() { return this.formNewNft?.get('urlWhitepaperPdf'); }
  get urlDosierPdf() { return this.formNewNft?.get('urlDosierPdf'); }
  get urlInfoTokenPdf() { return this.formNewNft?.get('urlInfoTokenPdf'); }
  get urlImagenPrincipal() { return this.formNewNft?.get('urlImagenPrincipal'); }
  get toBlockchain() { return this.formNewNft?.get('toBlockchain'); }
  get onlyInversors() { return this.formNewNft?.get('onlyInversors'); }
  get percentageToPrivateSale() { return this.formNewNft?.get('percentageToPrivateSale'); }
  get managingInvestments() {
    return this.formNewNft?.get('managingInvestments');
  } // Nuevo getter para managingInvestments
  get nameTokens() { return this.formNewNft?.get('nameTokens'); }
  get symbolTokens() { return this.formNewNft?.get('symbolTokens'); }
  get propertyType() { return this.formNewNft?.get('propertyType'); }
  get infoProyecto() { return this.formNewNft?.get('infoProyecto'); }
  get isMultipleVivienda() { return this.formNewNft?.get('isMultipleVivienda'); }
  get atributos() { return this.formNewNft?.get('atributos'); }

  // Métodos para hacer los checkboxes mutuamente excluyentes
  onManagingInvestmentsChange(event: any) {
    if (event.target.checked) {
      this.onlyInversors?.patchValue(false);
    }
  }

  onOnlyInversorsChange(event: any) {
    if (event.target.checked) {
      this.managingInvestments?.patchValue(false);
    }
  }

  // Método para manejar el cambio del checkbox de viviendas múltiples
  onMultipleViviendaChange(event: any) {
    const isMultiple = event.target.checked;
    
    if (isMultiple) {
      // Limpiar validaciones del campo atributos
      this.atributos?.clearValidators();
      this.atributos?.updateValueAndValidity();
      
      // Añadir validaciones a viviendas
      this.primeraVivienda.get('nombre')?.setValidators([Validators.required]);
      this.primeraVivienda.get('atributos')?.setValidators([Validators.required]);
      this.primeraVivienda.updateValueAndValidity();
      
      // Añadir validaciones a viviendas adicionales
      this.viviendasArray.controls.forEach(vivienda => {
        vivienda.get('nombre')?.setValidators([Validators.required]);
        vivienda.get('atributos')?.setValidators([Validators.required]);
        vivienda.updateValueAndValidity();
      });
    } else {
      // Limpiar validaciones de viviendas
      this.primeraVivienda.get('nombre')?.clearValidators();
      this.primeraVivienda.get('atributos')?.clearValidators();
      this.primeraVivienda.updateValueAndValidity();
      
      this.viviendasArray.controls.forEach(vivienda => {
        vivienda.get('nombre')?.clearValidators();
        vivienda.get('atributos')?.clearValidators();
        vivienda.updateValueAndValidity();
      });
      
      // Añadir validaciones al campo atributos
      this.atributos?.setValidators([Validators.required]);
      this.atributos?.updateValueAndValidity();
    }
  }

  // Métodos para manejar viviendas múltiples
  getViviendaControl(index: number, field: string): FormControl | null {
    if (index === 0) {
      return this.primeraVivienda.get(field) as FormControl;
    } else {
      const vivienda = this.viviendasArray.at(index - 1);
      return vivienda ? vivienda.get(field) as FormControl : null;
    }
  }

  anadirVivienda() {
    const nuevaVivienda = new FormGroup({
      nombre: new FormControl('', [Validators.required]),
      atributos: new FormControl('', [Validators.required])
    });
    this.viviendasArray.push(nuevaVivienda);
  }

  eliminarVivienda(index: number) {
    this.viviendasArray.removeAt(index);
  }

  ordenarAtributosVivienda(index: number) {
    try {
      let atributosControl: FormControl | null = null;
      
      if (index === 0) {
        atributosControl = this.primeraVivienda.get('atributos') as FormControl;
      } else {
        const vivienda = this.viviendasArray.at(index - 1);
        atributosControl = vivienda ? vivienda.get('atributos') as FormControl : null;
      }

      if (atributosControl) {
        const atributosOrdenados = this.getAtributosJsonFromString(atributosControl.value);
        
        const atributosString = `{${Object.entries(atributosOrdenados)
          .map(
            ([key, value]) =>
              `"${key}": ${typeof value === 'string' ? `"${value}"` : value}`
          )
          .join(', ')}}`;
        
        atributosControl.setValue(atributosString);
      }
    } catch (error) {
      console.error('Error en ordenarAtributosVivienda:', error);
    }
  }

  getAtributosJsonFromString(atributosString: string): Record<string, any> {
    const trimmedString = atributosString?.trim() || '{}';

    try {
      const sanitizedString =
        trimmedString.startsWith('{') && trimmedString.endsWith('}')
          ? trimmedString
          : `{${trimmedString}}`;

      // Parsear el JSON string
      const atributos = JSON.parse(sanitizedString);

      const atributosOrdenados: Record<string, any> = {};

      // Primero, añadir los atributos en un orden especifico
      this.ordenAtributos.forEach((key) => {
        if (key in atributos) {
          atributosOrdenados[key] = atributos[key];
          delete atributos[key];
        }
      });

      // Luego, añadir los atributos que quedan
      Object.assign(atributosOrdenados, atributos);

      return atributosOrdenados;
    } catch (error) {
      console.error("Error al analizar la cadena JSON en 'atributos':", error);
      return {};
    }
  }

  // Método para obtener todas las viviendas como array
  getAllViviendas(): Array<{nombre: string, atributos: Record<string, any>}> {
    const viviendas: Array<{nombre: string, atributos: Record<string, any>}> = [];
    
    // Añadir primera vivienda
    const primeraNombre = this.primeraVivienda.get('nombre')?.value;
    const primeraAtributos = this.getAtributosJsonFromString(this.primeraVivienda.get('atributos')?.value || '{}');
    if (primeraNombre) {
      viviendas.push({
        nombre: primeraNombre,
        atributos: primeraAtributos
      });
    }

    // Añadir viviendas adicionales
    this.viviendasArray.controls.forEach(vivienda => {
      const nombre = vivienda.get('nombre')?.value;
      const atributos = this.getAtributosJsonFromString(vivienda.get('atributos')?.value || '{}');
      if (nombre) {
        viviendas.push({
          nombre: nombre,
          atributos: atributos
        });
      }
    });

    return viviendas;
  }

  // Método para ordenar atributos (formato antiguo)
  ordenarAtributos() {
    try {
      const atributosOrdenados = this.getAtributosJsonFromString(this.atributos?.value || '{}');
      
      const atributosString = `{${Object.entries(atributosOrdenados)
        .map(
          ([key, value]) =>
            `"${key}": ${typeof value === 'string' ? `"${value}"` : value}`
        )
        .join(', ')}}`;
      
      this.atributos?.setValue(atributosString);
    } catch (error) {
      console.error('Error en ordenarAtributos:', error);
    }
  }

  async newNft() {
    // Validar formulario principal
    if (this.formNewNft.invalid) { 
      this.formNewNft.markAllAsTouched();
      return; 
    }

    const isMultipleVivienda = this.isMultipleVivienda?.getRawValue();

    if (isMultipleVivienda) {
      // Validar primera vivienda
      if (this.primeraVivienda.invalid) {
        this.primeraVivienda.markAllAsTouched();
        return;
      }

      // Validar viviendas adicionales
      if (this.viviendasArray.invalid) {
        this.viviendasArray.markAllAsTouched();
        return;
      }
    }

    // Verificar si el usuario es administrador
    const isAdmin = this.authService.admin.getValue();
    
    if (!isAdmin) {
      // Verificar en la colección de administradores como respaldo
      const user = this.authService.userAuth.getValue();
      if (user) {
        this.afs.collection('administrators').doc(user.uid).get().subscribe(doc => {
          if (doc.exists) {
            const adminData = doc.data() as any;
            if (adminData && (adminData.rol === 'admin' || adminData.rol === 'superadmin')) {
              // Intentar refrescar los claims
              this.authService.checkAdmin();
            }
          }
        });
      }
      
      Swal.fire({
        icon: 'error',
        title: 'Acceso denegado',
        text: 'Solo los administradores pueden crear proyectos. Contacta al administrador del sistema.'
      });
      return;
    }

    
    // Bloquear UI mientras se guarda
    this.loadingFlag = true;
    this.formNewNft.disable({ emitEvent: false });

    const imagesUrls: string[] = this.pushImages();
    
    let viviendas = null;
    let atributos = null;

    if (isMultipleVivienda) {
      viviendas = this.getAllViviendas();
    } else {
      atributos = this.getAtributosJsonFromString(this.atributos?.value || '{}');
    }

    const item: any = {
      id: this.id,
      hide: false,
      title: this.titulo?.getRawValue(),
      company: this.promotora?.getRawValue(),
      country: this.pais?.getRawValue(),
      stateCCAAProvince: this.estadoCCAAProvincia?.getRawValue(),
      location: this.localidad?.getRawValue(),
      neighborhood: this.barrio?.getRawValue(),
      cp: this.codigoPostal?.getRawValue(),
      street: this.calle?.getRawValue(),
      iframeGoogleMaps: this.iframeGoogleMaps?.getRawValue(),
      description: this.descripcion?.getRawValue(),
      activationDate: this.fechaActivado?.getRawValue() ? new Date(this.fechaActivado.getRawValue()) : null,
      estimatedDeliveryTime: this.plazoEstimadoEntrega?.getRawValue(),
      annualReturn: this.rentabilidadAnual?.getRawValue(),
      amountSold: 0,
      amountToSell: this.amountToSell?.getRawValue(),
      priceToken: this.precioToken?.getRawValue() * 100,
      minimumInvestment: this.inversionMinima?.getRawValue(),
      stableCoinAddress: this.stableCoinAddress?.getRawValue(),
      beneficiaryAddress: this.beneficiaryAddress?.getRawValue(),
      aggregatorStableCoinDolar: this.aggregatorStableCoinDolar?.getRawValue(),
      urlWhitepapperPdf: this.whitePaper,
      urlDosierPdf: this.dosier,
      urlInfoTokenPdf: this.infoToken,
      proyectStatus: 'En estudio',
      isMultipleVivienda: isMultipleVivienda,
      ...(isMultipleVivienda ? { viviendas: viviendas } : { attributes: atributos }),
      blockchain: this.toBlockchain?.getRawValue(),
      onlyInversors: this.onlyInversors?.getRawValue(),
      managingInvestments: this.managingInvestments?.getRawValue(), // Añadido para gestionar inversión
      nameTokens: this.nameTokens?.getRawValue(),
      symbolTokens: this.symbolTokens?.getRawValue(),
      mainImage: this.fotoMain,
      images: imagesUrls,
      sellerAddress: null,
      tokensAddress: null,
      dividendsAddress: null,
      NftID: null,
      endOfSale: 0,
      numberInvestors: 0,
      hoursToSell: 0,
      infoProyecto: this.infoProyecto?.getRawValue(),
      propertyType: this.propertyType?.getRawValue() || 'Flipping House', // Tipo de propiedad con fallback
      ...(this.onlyInversors?.getRawValue() ? { percentageToPrivateSale: this.percentageToPrivateSale?.getRawValue() } : {})
    };
    
    this.addInvestment(item);
  }

  addInvestment(item: any) {
    
    this.afs.collection('investments').doc(this.id).set(item, {merge: true})
      .then(async() => {
        // Registrar la transición inicial de estado
        try {
          
          // Obtener el uid del usuario que está creando el proyecto
          const user = this.authService.userAuth.getValue();
          const userId = user?.uid || 'auto-system';
          
          if (user) {
            user.getIdTokenResult().then((tokenResult: any) => {
            });
          }
          
          await this.timelineService.recordTransition(
            this.id,
            null,
            'En estudio',
            'Proyecto creado',
            userId
          );
        } catch (error: any) {
          console.error('🔧 [DEBUG] Error registrando transición inicial:', error);
          console.error('🔧 [DEBUG] Error details:', {
            message: error?.message,
            code: error?.code,
            stack: error?.stack
          });
          // No fallar si no se puede registrar la transición
        }

        await this.createProjectWallet(this.id);
        
        if (this.toBlockchain?.getRawValue() === true) {
          const _id = this.id;
          this.addProyectToBlockchain(_id);
        } else {
          Swal.fire({
            icon: 'success',
            text: `Proyecto subido a la BBDD (No blockchain)`
          });

          this.id = Date.now().toString();
          this.formNewNft.reset();
          this.resetVariables();
          this.resetViviendas();
          this.stableCoinAddress?.patchValue('0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063');
          this.aggregatorStableCoinDolar?.patchValue('0x4746DeC9e833A82EC7C2C1356372CcF2cfcD2F3D');
          this.loadingFlag = false;
          this.formNewNft.enable({ emitEvent: false });
        }
      })
      .catch((error) => { 
        console.error('Error en addInvestment:', error);
        this.id = Date.now().toString();

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Algo ha ido mal!'
        });
        this.loadingFlag = false;
        this.formNewNft.enable({ emitEvent: false });
      });
  }

  async addProyectToBlockchain(id: string) {
    Swal.fire({
      title: 'Procesando...',
      html: 'No cierres esta pantalla!!',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });

    const baseFee: number = await this.web3.eth.getBlock('pending').then((block: any) => { 
      return Number(block.baseFeePerGas) + 100000000000; 
    });

    this.contractManager.methods.mintNft(
      this.formatToWei(this.amountToSell?.getRawValue()),
      id,
      this.stableCoinAddress?.getRawValue(),
      this.beneficiaryAddress?.getRawValue(),
      this.aggregatorStableCoinDolar?.getRawValue(),
      this.nameTokens?.getRawValue(),
      this.symbolTokens?.getRawValue()
    ).send({from: this.ourAddress, maxFeePerGas: this.web3.utils.toHex(baseFee), maxPriorityFeePerGas: this.web3.utils.toHex(this.web3.utils.toWei('50', 'gwei'))}) 
      .then(() => {
        this.web3.eth.getBlockNumber().then((res: any) => {
          const blockNumber: number = res;

          this.contractManager.getPastEvents('newMint', {
            fromBlock: blockNumber - 8
          }, (err: any, events: any) => { 
            const e = events[0];
  
            if (this.web3.utils.sha3(id) === e.returnValues.uri) {
              this.afs.collection('investments').doc(id).set({
                sellerAddress: e.returnValues.e_seller,
                tokensAddress: e.returnValues.e_holdings,
                dividendsAddress: e.returnValues.e_dividends,
                NftID: e.returnValues.e_NftID
              }, {merge: true}).then(() => {
                this.loadingFlag = false;
                this.formNewNft.enable({ emitEvent: false });
                Swal.close();
                Swal.fire({
                  icon: 'success',
                  text: `Proyecto subido a la BBDD y a la Blockchain`
                });
        
                this.id = Date.now().toString();
                this.formNewNft.reset();
                this.resetVariables();
                this.resetViviendas();
                this.stableCoinAddress?.patchValue('0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063');
                this.aggregatorStableCoinDolar?.patchValue('0x4746DeC9e833A82EC7C2C1356372CcF2cfcD2F3D');
              });
            }
          });
        });
      })
      .catch(() => {
        this.afs.collection('investments').doc(id).delete();
        this.id = Date.now().toString();

        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Transacción errónea',
          text: 'Algo ha ido mal, la transacción NO se ha realizado'
        });
        this.loadingFlag = false;
        this.formNewNft.enable({ emitEvent: false });
      });
  }

  formatToWei(num: number) {
    return this.web3.utils.toWei(num.toString(), 'ether');
  }

  resetVariables() {
    this.fotoMain = null;
    this.foto1 = null;
    this.foto2 = null;
    this.foto3 = null;
    this.foto4 = null;
    this.foto5 = null;
    this.foto6 = null;
    this.foto7 = null;
    this.foto8 = null;
    this.foto9 = null;
    this.foto10 = null;

    this.whitePaper = null;
    this.dosier = null;
    this.infoToken = null;
  }

  resetViviendas() {
    // Reset primera vivienda
    this.primeraVivienda.reset();
    this.primeraVivienda.patchValue({
      nombre: '',
      atributos: ''
    });

    // Limpiar viviendas adicionales
    this.viviendasArray.clear();
  }

  pushImages(): string[] {
    let images: string[] = [];

    (this.foto1 !== null) ? images.push(this.foto1) : null;
    (this.foto2 !== null) ? images.push(this.foto2) : null;
    (this.foto3 !== null) ? images.push(this.foto3) : null;
    (this.foto4 !== null) ? images.push(this.foto4) : null;
    (this.foto5 !== null) ? images.push(this.foto5) : null;
    (this.foto6 !== null) ? images.push(this.foto6) : null;
    (this.foto7 !== null) ? images.push(this.foto7) : null;
    (this.foto8 !== null) ? images.push(this.foto8) : null;
    (this.foto9 !== null) ? images.push(this.foto9) : null;
    (this.foto10 !== null) ? images.push(this.foto10) : null;

    return images;
  }

  

  uploadImg(e: any, id: string) {
    this.loadingFlag = true;
    const file = e.target.files[0];

    const filePath = `investments/${this.id}/${file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe({
          next: (res: string) => {
            (id === 'fotoPrincipal') ? this.fotoMain = res : null;
            (id === 'foto1') ? this.foto1 = res : null;
            (id === 'foto2') ? this.foto2 = res : null;
            (id === 'foto3') ? this.foto3 = res : null;
            (id === 'foto4') ? this.foto4 = res : null;
            (id === 'foto5') ? this.foto5 = res : null;
            (id === 'foto6') ? this.foto6 = res : null;
            (id === 'foto7') ? this.foto7 = res : null;
            (id === 'foto8') ? this.foto8 = res : null;
            (id === 'foto9') ? this.foto9 = res : null;
            (id === 'foto10') ? this.foto10 = res : null;
          },
          error: (err) => {
            console.error('Error getting download URL:', err);
          },
          complete: () => {
            this.loadingFlag = false; // Always reset loading flag
          }
        });
      })).subscribe();
  }

  uploadWhitepaper(e: any) {
    this.loadingFlag = true;
    const file = e.target.files[0];

    const filePath = `investments/${this.id}/${file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe({
          next: (res: string) => {
            this.whitePaper = res;
          },
          error: (err) => {
            console.error('Error uploading whitepaper:', err);
          },
          complete: () => {
            this.loadingFlag = false; // Always reset loading flag
          }
        });
      })).subscribe();
  }

  uploadDosier(e: any) {
    this.loadingFlag = true;
    const file = e.target.files[0];

    const filePath = `investments/${this.id}/${file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe({
          next: (res: string) => {
            this.dosier = res;
          },
          error: (err) => {
            console.error('Error uploading dosier:', err);
          },
          complete: () => {
            this.loadingFlag = false; // Always reset loading flag
          }
        });
      })).subscribe();
  }

  uploadInfoToken(e: any) {
    this.loadingFlag = true;
    const file = e.target.files[0];

    const filePath = `investments/${this.id}/${file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe({
          next: (res: string) => {
            this.infoToken = res;
          },
          error: (err) => {
            console.error('Error uploading info token:', err);
          },
          complete: () => {
            this.loadingFlag = false; // Always reset loading flag
          }
        });
      })).subscribe();
  }

  urlValidator(control: AbstractControl): { [key: string]: any } | null {
    const validUrlRegex = /^(ftp|http|https):\/\/(?:(?:[a-z0-9][a-z0-9-]*[a-z0-9]\.)+[a-z]{2,}|((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(?::[0-9]{1,5})?(?:\/[^\s]*)?$/i;
    const value = control.value;
    const isValid = validUrlRegex.test(value);
    return isValid ? null : { 'invalidUrl': { value } };
  }

  async createProjectWallet(projectId: string) {
    try {
      this.loaderService.showSpinner('Creando wallet para el proyecto');
      const response = await this.fns.httpsCallable('setProjectWallet')({ projectId }).toPromise();
    } catch (err) {
      console.error('Error creando wallet del proyecto:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error en Cloud Function',
        text: 'Ha ocurrido un error creando la wallet del proyecto. Verifica la consola para más detalles.'
      });
      // No eliminar el proyecto si falla la wallet, solo mostrar error
      // await this.afs.collection('investments').doc(projectId).delete();
    } finally {
      this.loaderService.hideSpinner();
    }
  }


}
